import React from 'react';
import dayjs from "dayjs";
import { Button, DatePicker } from 'antd';

const DaySelect = ({ date, setDate }) => {
    const handleDateChange = (date) => {
        setDate(dayjs(date).endOf('day'));
    }

    const handleGoToPreviousDay = () => {
        if(dayjs(date).isBefore(dayjs('2024-12-20'))) return;
        setDate(dayjs(date).subtract(1, 'day').endOf('day'));
    }

    const handleGoToNextDay = () => {
        if(dayjs(date).isAfter(dayjs())) return;
        setDate(dayjs(date).add(1, 'day').endOf('day'));
    }

    return (
        <div style={{ marginRight: '10px'}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                    onClick={handleGoToPreviousDay}
                    style={{ marginRight: '5px', alignSelf: 'center' }}
                    disabled={dayjs(date).subtract(1, 'day').isBefore(dayjs('2024-12-20').startOf('day'))}
                >
                    이전날
                </Button>
                <DatePicker
                    picker="date"
                    minDate={dayjs('2024-12-20')}
                    maxDate={dayjs()}
                    value={dayjs(date)}
                    onChange={handleDateChange}
                    allowClear={false}
                    style={{ marginRight: '5px' }}
                />
                <Button
                    onClick={handleGoToNextDay}
                    style={{ alignSelf: 'center' }}
                    disabled={dayjs(date).add(1, 'day').isAfter(dayjs())}
                >
                    다음날
                </Button>
            </div>
        </div>
    );
}

export default DaySelect;